import PropTypes from 'prop-types';

var propTypes = {
    text: PropTypes.string,
    prefixIcon: PropTypes.object,
    suffixIcon: PropTypes.object,
    onClick: PropTypes.func,
    isDisabled: PropTypes.bool,
    isSelected: PropTypes.bool,
    className: PropTypes.string,
    truncateText: PropTypes.bool,
};
var defaultProps = {
    isDisabled: false,
    isSelected: false,
    className: '',
    truncateText: true,
};

export { defaultProps, propTypes };
